import type { PatientChatResponseDetail } from '@mummssoftware/utils';

/** Slider positions 0..4, left to right. Sent to the agent as responseDetail. */
export const RESPONSE_DETAIL_LEVELS: PatientChatResponseDetail[] = [
  'brief',
  'succinct',
  'balanced',
  'detailed',
  'verbose',
];

export const DEFAULT_RESPONSE_DETAIL: PatientChatResponseDetail = 'balanced';

export const responseDetailIndex = (
  detail: PatientChatResponseDetail | string | null | undefined,
): number => {
  const index = RESPONSE_DETAIL_LEVELS.indexOf(
    detail as PatientChatResponseDetail,
  );
  return index === -1
    ? RESPONSE_DETAIL_LEVELS.indexOf(DEFAULT_RESPONSE_DETAIL)
    : index;
};

/**
 * Days of chart data every chat covers: the last MAX_RANGE_DAYS by default, or
 * MAX_RANGE_DAYS from the start date picked for a patient referred earlier.
 */
export const MAX_RANGE_DAYS = 365;

/** Rows requested for the per-patient history grid. */
export const HISTORY_PAGE_SIZE = 100;

/** Messages requested for one conversation (a question and its answer are two). */
export const CONVERSATION_MESSAGES_PAGE_SIZE = 200;

/**
 * After this long without a reply the widget says so and unlocks the composer.
 * The request keeps running; a reply that arrives later is still shown.
 */
export const SLOW_REPLY_MS = 30000;

/**
 * Longest wait for any other gateway call (start, end, cancel, past answer,
 * history). Past it the widget reports the server as not responding and
 * unlocks, instead of spinning for as long as the request hangs.
 */
export const REQUEST_TIMEOUT_MS = 20000;

/** From this share of the agency's token pool, the chat shows how much is used. */
export const TOKEN_USAGE_NOTICE_PERCENT = 80;
